import { Link } from "react-router-dom";

const guildStats = [
  { icon: "ri-trophy-line", label: "Tournaments", val: "120+", color: "#00ff88" },
  { icon: "ri-team-line", label: "Active Members", val: "300+", color: "#f59e0b" },
  { icon: "ri-gamepad-line", label: "Games Supported", val: "15+", color: "#00ff88" },
  { icon: "ri-shield-star-line", label: "Guilds Managed", val: "50+", color: "#f59e0b" },
];

export default function GuildBanner() {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e775b66b27794a37ba7917c8ef7ecb3e.jpg"
          alt="AWWAL Gaming Arena"
          className="w-full h-full object-cover object-top opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#080808] via-[#080808]/60 to-[#080808]" />
      </div>
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div>
          <div className="text-[#f59e0b] text-xs tracking-[0.3em] uppercase font-semibold mb-4 font-inter">Guild Operations</div>
          <h2 className="text-4xl lg:text-5xl font-black text-white tracking-tight mb-6 leading-tight font-syne">
            Run Your Guild Like<br />a <span className="text-[#00ff88]">Pro Organization</span>
          </h2>
          <p className="text-white/45 text-base leading-relaxed mb-8 font-inter">
            AWWAL's guild management platform gives your community the tools to recruit smarter, compete harder, and grow faster. Trusted by 300+ guilds across Southeast Asia.
          </p>

        </div>
        <div className="grid grid-cols-2 gap-4">
          {guildStats.map((item) => (
            <div
              key={item.label}
              className="p-6 bg-white/5 rounded-sm border border-white/5 hover:bg-white/8 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-4 rounded-sm" style={{ background: `${item.color}14` }}>
                <i className={`${item.icon} text-lg leading-none`} style={{ color: item.color }} />
              </div>
              <div className="text-3xl font-black text-white mb-1 font-syne">{item.val}</div>
              <div className="text-white/35 text-xs tracking-widest uppercase font-inter">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
